// DEV
export const API_URL_ASSORTMENT_HIERARCY =
  "https://ctbadmin-api-dev.truevalue.com/api/ctbbaseapi/Assortment";

export const API_URL_CATEGORY_HIERARCY =
  "https://ctbadmin-api-dev.truevalue.com/api/ctbbaseapi/Category";

export const API_URL_SUBCAT_HIERARCY =
  "https://ctbadmin-api-dev.truevalue.com/api/ctbbaseapi/SubCategory";

export const API_URL_FIXTURE =
  "https://ctbadmin-api-dev.truevalue.com/api/ctbbaseapi/Planogram";

export const API_URL_RESTRICTION =
  "https://ctbadmin-api-dev.truevalue.com/api/ctbbaseapi/Restriction"

